import React, { useMemo } from 'react'

import { array, string } from 'prop-types'

import CategoryItem from '../CategoryItem/CategoryItem'

// Categories section: a section header above a two-sub-column grid of category rows.
// The list is split in half so it fills two balanced columns, matching the Figma
// layout (desktop and mobile both keep the two columns; CSS handles the reflow).
// browseAll* is threaded down so the mobile subcategory drill-in can pin the same
// "Browse all" row at its top (see SubcategoryFlyout).
function Categories({ categories, title, browseAllHref, browseAllLabel }) {
  const [column1, column2] = useMemo(() => {
    const half = Math.ceil(categories.length / 2)

    return [categories.slice(0, half), categories.slice(half)]
  }, [categories])

  return (
    <div className="category-mega-menu__section category-mega-menu__section--categories">
      <h4 className="category-mega-menu__heading cgt-overline-md">{title}</h4>
      <div className="category-mega-menu__categories-grid">
        {[column1, column2].map((column, columnIndex) => (
          // eslint-disable-next-line react/no-array-index-key
          <div key={`category-column-${columnIndex}`} className="category-mega-menu__categories-column">
            {column.map((category) => (
              <CategoryItem
                key={category.title}
                title={category.title}
                iconSlug={category.slug}
                href={category.path}
                subcategories={category.subcategories}
                browseAllHref={browseAllHref}
                browseAllLabel={browseAllLabel}
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  )
}

Categories.propTypes = {
  categories: array.isRequired,
  title: string.isRequired,
  browseAllHref: string.isRequired,
  browseAllLabel: string.isRequired,
}

export default Categories
